// extracted by mini-css-extract-plugin
module.exports = {"isEditing":"root_isEditing__LS61K","header":"root_header__5q3vM"};